import { Form, Select } from 'antd'
import { FC } from 'react'
import { CustomFormInstance } from '../../../../types'
import { MachineForm, MachineNames } from '../types'

type Props = {
    form: CustomFormInstance<MachineForm>
}

const AdditionalComponentsForCharacteristics: FC<Props> = ({ form }) => {
    const additionalComponents =
        (form.getFieldValue(
            MachineNames.primaryAdditionalComponents
        ) as MachineForm['primaryAdditionalComponents']) ?? []

    return (
        <Form.Item name="additionalComponentsForCharacteristics">
            <Select
                mode="multiple"
                options={additionalComponents.map((item) => ({
                    value: item.id ?? '',
                    label: item.component,
                }))}
            />
        </Form.Item>
    )
}

export default AdditionalComponentsForCharacteristics
